import _ from "underscore";
import templateUrl from 'emun.salesrep/salesrep-monthly-goals.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import GoalsPrompt from "emun.salesrep/salesrep-goals-prompt";
import salesrepConfig from 'emun.salesrep/salesrep.config'
import ServiceBus from "servicestack/service-bus";
import TransferPrompt from "emun.salesrep/transfer-goals-prompt";
import modals from "webmodals/modals";

class SalesRepMonthlyGoalsController {
  constructor($rootScope) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.bus = new ServiceBus();
    $ctrl.years = [];
    $ctrl.years.push(moment().add(-1, 'year').format('YYYY'));
    $ctrl.years.push(moment().format('YYYY'));
    $ctrl.years.push(moment().add(1, 'year').format('YYYY'));
  }
  $onInit() {
    const $ctrl = this;
    var url = 'QueryRepMonthlyGoals.json';

    $ctrl.goalType = "goal";
    $ctrl.goalsQuery = new AutoQuery({
      url: url,
      orderBy: 'RepId,VendorId,StartDate',
      autoLoad: false,
      pageSize: 10000,
      scrollTop: false,
      onLoaded: function (args) {
        $ctrl.goals = _.groupBy(_.sortBy(args.results, 'repName'), 'repName');
      }
    });
    $ctrl.goalsQuery.criteria.year = moment().format('YYYY');
    if ($ctrl.goalsQuery.criteria.vendorId == undefined) {
      url = url + "?VendorIDIsEmpty=1"
      $ctrl.goalsQuery.url = url;
    }
    if ($ctrl.salesrepConfig.adminGoalsBy !== 'Category') $ctrl.goalsQuery.load();

    $ctrl.bus.send('QuerySalesRepList.json?Active=1&OrderBy=Name').then(function (res) {
      $ctrl.reps = res.data.results;
    });
  }
  loadQuery() {
    const $ctrl = this;
    var url = 'QueryRepMonthlyGoals.json';
    if ($ctrl.goalsQuery.criteria.vendorId == undefined && !$ctrl.goalsQuery.criteria.allRepGoals) {
      url = url + "?VendorIDIsEmpty=1"
    }
    if ($ctrl.salesRep) {
      $ctrl.goalsQuery.criteria.repId = $ctrl.salesRep.id;
    }
    $ctrl.goalsQuery.url = url;
    $ctrl.goalsQuery.load()
  }
  edit(value) {
    const $ctrl = this;
    GoalsPrompt.open({ repId: value, vendorId: $ctrl.goalsQuery.criteria.vendorId, categoryId: $ctrl.goalsQuery.criteria.categoryId }).then(() => $ctrl.goalsQuery.load());
  }
  create() {
    const $ctrl = this;
    GoalsPrompt.open({ repId: $ctrl.goalsQuery.criteria.repId, vendorId: $ctrl.goalsQuery.criteria.vendorId, categoryId: $ctrl.goalsQuery.criteria.categoryId }).then(() => $ctrl.goalsQuery.load());
  }
  transfer() {
    const $ctrl = this;
    TransferPrompt.open().then(() => $ctrl.goalsQuery.load());
  }
  deleteRepGoal() {
    const $ctrl = this;
    if ($ctrl.salesRep && $ctrl.salesRep.id != undefined && $ctrl.salesRep.id != "") {
      return modals.confirm("Are you sure you want to delete all goals for rep " + $ctrl.salesRep.name + "?", "Delete Goal").result.then(function () {
        $ctrl.bus.send('DeleteRepMonthlyGoals.json?', {
          RepId: $ctrl.salesRep.id
        }).then(function (response) {
          $ctrl.loadQuery();
        });
      });
    } else {
      return modals.confirm("You must select a rep?", "Delete Goal").result.then(function () {
        
      });
    }
    
  }
  cleanCsvValue = function (value) {
    return value
      .replace(/^\s*|\s*$/g, "") // remove leading & trailing space
      .replace(/^"|"$/g, "") // remove " on the beginning and end
      .replace(/""/g, '"'); // replace "" with "
  }

  csvToJSON = function (content) {
    let $ctrl = this;
    var lines = content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
    var result = [];
    var start = 0;
    var columnCount = lines[0].split(content.separator).length;

    var headers = [];
    if (content.header) {
      headers = lines[0].split(content.separator);
      start = 1;
    }

    for (var i = start; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
      if (currentline.length === columnCount) {
        if (content.header) {
          for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = $ctrl.cleanCsvValue(currentline[j]);
          }
        } else {
          for (var k = 0; k < currentline.length; k++) {
            obj[k] = $ctrl.cleanCsvValue(currentline[k]);
          }
        }
        obj.goalType = $ctrl.goalType;
        result.push(obj);
      }
    }
    return result;
  }
  processFile = function (file) {
    let $ctrl = this;
    $ctrl.finished = false;
    $ctrl.filename = file.name;
    $ctrl.cleanFile = true;
    $ctrl.errors = [];
    $ctrl.errors.errorCodes = [];
    var reader = new FileReader();
    reader.onload = function (ev) {
      var content = {
        csv: ev.target.result.replace(/\r\n|\r/g, '\n'),
        header: true,
        separator: ','
      };
      $ctrl.content = content.csv;
      $ctrl.result = $ctrl.csvToJSON(content);
      $ctrl.finished = false;
      return $ctrl.bus.send('ImportSalesGoals.json', { items: $ctrl.result }).then(function (response) {
        $ctrl.finished = true;
        $ctrl.result = null;
        $ctrl.goalsQuery.load(true);
      });
    };
    reader.readAsText(file);
  }
}

let SalesRepMonthlyGoals = {
  bindings: {
    rep: '<',
    vendor: '@'
  },
  controller: SalesRepMonthlyGoalsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepMonthlyGoals